// extracted by mini-css-extract-plugin
export default {"root":"print_root__lAKkg","page":"print_page__aJ1rC","box":"print_box__emrrh","flex":"print_flex__RH6Kj","text-right":"print_text-right__XNrkq","summery":"print_summery__w0zNA"};